module.exports = __webpack_public_path__ + "static/media/Clipboard.2f1a997d.svg";